<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right"
                   style="font-size: 20px; padding: 20px 10px 20px; background-color: #e6e5e5;">
      <el-breadcrumb-item>Optimization</el-breadcrumb-item>
      <el-breadcrumb-item>Result</el-breadcrumb-item>
    </el-breadcrumb>
    <br>
    <h3>Identification</h3>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-image :src="'https://www.csuligroup.com/AIDrugDesigner/getimgdownloadurl' + this.$route.params.fig_path"></el-image>
      </el-col>
      <el-col :span="12">
        <el-descriptions class="margin-top" :column="1" :size="medium" border>
          <el-descriptions-item>
            <template slot="label">
              SMILES
            </template>
            {{ this.$route.params.SMILES }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              InChI
            </template>
            {{ this.$route.params.inich }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              InChI Key
            </template>
            {{ this.$route.params.inchikey }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              Molecular Formula
            </template>
            {{ this.$route.params.Formula }}
          </el-descriptions-item>
        </el-descriptions>
      </el-col>
    </el-row>
    <h3>Calculated Properties</h3>
    <el-descriptions class="margin-top" :column="2" :size="medium" border>
      <el-descriptions-item v-for="item in calculatedProperties" :key="item[0]">
        <template slot="label" >{{ item[0] }}</template>
        {{ item[1] }}
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
export default {
  name: "Detail",
  data() {
    return {
      calculatedProperties: {}
    }
  },
  created() {
    this.calculatedProperties = Object.entries(this.$route.params).slice(5);
  }
}
</script>

<style scoped>
div {
  min-height: 100%;
  text-align: left;
  max-width: 1140px;
  margin: 0 auto;
}
</style>
